$(document).ready(function () {
  // Secondary Nav Dropdowns
  var $secondaryDropdown = $(".has-secondary");

  if ($secondaryDropdown.length) {
    $(".has-secondary").click(function (e) {
      var $this = $(this);

      e.preventDefault();

      if ($(".main-nav__secondary").hasClass("open")) {
        $this.removeClass("secondary-open");
        $this.siblings(".main-nav__secondary").removeClass("open");
      } else {
        $this.addClass("secondary-open");
        $this.siblings(".main-nav__secondary").addClass("open");
      }
    });
  }

  // Mobile Nav
  $(".mobile-toggle-menu").click(function (e) {
    e.preventDefault();

    if ($(".header").hasClass("mobile-nav-open")) {
      $(".mobile-nav").removeClass("shown");
      $(".header").removeClass("mobile-nav-open");
    } else {
      $(".mobile-nav").addClass("shown");
      $(".header").addClass("mobile-nav-open");
    }
  });

  // Slideshow
  var $mainSlideshow = $(".slideshow");

  if ($mainSlideshow.length) {
    $(".slideshow").on("init", function (event, slick) {
      $this = $(this);

      setTimeout(function () {
        $this.find(".slideshow__content").addClass("shown");
      }, 1000);
    });

    $(".slideshow").on("beforeChange", function (event, slick) {
      $(this).find(".slideshow__content").removeClass("shown");
    });

    $(".slideshow").on("afterChange", function (event, slick) {
      $(this).find(".slideshow__content").addClass("shown");
    });

    $mainSlideshow.slick({
      speed: 1000,
      prevArrow: $(".prev-arrow"),
      nextArrow: $(".next-arrow"),
      waitForAnimate: false,
      autoplay: $mainSlideshow.data("autoplay"),
      autoplaySpeed: $mainSlideshow.data("speed"),
      pauseOnHover: false,
    });
  } else {
    setTimeout(function () {
      $(".slideshow__content").addClass("shown");
    }, 1000);
  }

  $(".slideshow__arrow").click(function (e) {
    var $pageHeight = $(this).parents("section").innerHeight();

    e.preventDefault();
    $("html, body").stop().animate({ scrollTop: $pageHeight }, 1000);
  });

  $(".btn-smooth-scroll").click(function () {
    var $content = $(this).attr("href");
    $("html,body").animate(
      {
        scrollTop: $($content).offset().top,
      },
      "slow"
    );
  });

  // Testimonials
  var $mainTestimonials = $(".testimonials-slider");

  if ($mainTestimonials.length) {
    $(".testimonials-slider").slick({
      prevArrow: $(".prev-arrow"),
      nextArrow: $(".next-arrow"),
      infinite: false,
      autoplay: $mainTestimonials.data("autoplay"),
      autoplaySpeed: $mainTestimonials.data("speed"),
      pauseOnHover: false,
      adaptiveHeight: true,
    });
  }

  // Collection Slider
  var $collectionSlider = $(".collection-slider");

  if ($collectionSlider.length) {
    $(".collection-slider").slick({
      mobileFirst: true,
      arrows: false,
      dots: false,
      infinite: false,
      slidesToShow: 1,
      variableWidth: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows: true,
            prevArrow: $(".carousel-prev"),
            nextArrow: $(".carousel-next"),
            infinite: false,
            autoplaySpeed: $collectionSlider.data("speed"),
            adaptiveHeight: true,
            variableWidth: false,
          },
        },
      ],
    });
  }

  // Card Slider
  var $cardSlider = $(".section-cards");

  if ($cardSlider.length && !$("body").hasClass("template-experience-guided")) {
    $(".section-cards__cards").slick({
      mobileFirst: true,
      arrows: false,
      dots: false,
      infinite: false,
      slidesToShow: 1,
      variableWidth: true,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows: true,
            prevArrow: $(".carousel-prev"),
            nextArrow: $(".carousel-next"),
            infinite: false,
            autoplaySpeed: $collectionSlider.data("speed"),
            adaptiveHeight: true,
            variableWidth: false,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 999,
          settings: {
            arrows: true,
            prevArrow: $(".carousel-prev"),
            nextArrow: $(".carousel-next"),
            infinite: false,
            autoplaySpeed: $collectionSlider.data("speed"),
            adaptiveHeight: true,
            variableWidth: false,
            slidesToShow: 3,
          },
        },
      ],
    });
  }

  // Youtube
  var $slideshowVideo = $("#ytbg");

  if ($slideshowVideo.length) {
    $("[data-youtube]").youtube_background({
      mobile: true,
      "load-background": false,
    });
  }

  $(".collection-filter a").click(function (e) {
    var $this = $(this);
    var $sectionId = $(this).data("section");
    var headerHeight = $(".header").height();

    e.preventDefault();

    $("html, body").animate(
      {
        scrollTop: $("#" + $sectionId).offset().top - headerHeight,
      },
      600
    );
  });

  /* --- Cart Page ----------------------------- */

  if ($("body").hasClass("template-cart")) {
    $(".cart-item__change").on("change", function () {
      var line_item = $(this).data("item");
      var quantity = $(this).val();
      var $linePrice = $(this).parents("tr").find(".cart-item__line-price");

      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: { line: line_item, quantity: quantity },
        success: function (cart) {
          $(".cart__subtotal-price").text(
            Shopify.formatMoney(cart.total_price)
          );
          $(".header__cart-count").text(cart.item_count);

          for (var i = 0; i < cart.items.length; i++) {
            var item = cart.items[i];
            var price_element = $(".line-total-" + item.id);
            price_element.html(Shopify.formatMoney(item.line_price));
          }
        },
      });
    });

    $("#checkout_button").click(function (e) {
      if (!$("#purchasers_age").is(":checked")) {
        e.preventDefault();
        $('label[for="purchasers_age"]').addClass("error");
      }
    });
  }

  /* --- Product Page ----------------------------- */

  if ($("body").hasClass("template-product")) {
    // check if .stock-top exists every 100ms
    // if it does, put it before .product__add-to-cart
    // if it doesn't, check again in 100ms
    var stockTop = setInterval(function () {
      if ($(".stock-top").length) {
        $(".stock-top").insertBefore(".product__add-to-cart");
        $(".stock-top").show();
        clearInterval(stockTop);
      }
    }, 200);

    // Reviews
    var $productTestimonials = $(".product-testimonials-slider");

    if ($productTestimonials.length) {
      $(".product-testimonials-slider").slick({
        prevArrow: $(".prev-arrow"),
        nextArrow: $(".next-arrow"),
        infinite: false,
        speed: 1000,
        autoplay: $productTestimonials.data("autoplay"),
        autoplaySpeed: $productTestimonials.data("speed"),
        pauseOnHover: false,
        adaptiveHeight: true,
      });
    }

    $("#AddToCart").on("click", function (e) {
      e.preventDefault();
      var button = $(this);

      $(button).text(" ").addClass("loading");

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: $(this).parents("form").serialize(),
        success: function () {
          $(button)
            .html("Successfully added to your cart")
            .removeClass("loading")
            .addClass("success");

          jQuery.getJSON("/cart.js", function (cart) {
            $(".header__cart-count").text(cart.item_count);
          });

          setTimeout(function () {
            $(button).html("Add to Cart").removeClass("success");
          }, 3000);
        },
        error: function () {
          $(button).html("Please try again").removeClass("loading");

          setTimeout(function () {
            $(button).html("Add to Cart");
          }, 3000);
        },
      });
    });
  }

  /* --- Product Page - carousel ----------------------------- */

  if ($("body").hasClass("template-carousel")) {
    const $product_images = $(".product__images__featured__slider");
    const $product_thumbnails = $(".product__images__thumbnails");
    const $photosCounterFirstSpan = $(".photos-counter span:nth-child(1)");

    $product_thumbnails.on("init", (event, slick) => {
      $photosCounterFirstSpan.text(`${slick.currentSlide + 1} / `);
      $(".photos-counter span:nth-child(2)").text(slick.slideCount);
    });

    $product_images.slick({
      slidesToShow: 1,
      arrows: false,
      draggable: true,
      useTransform: false,
      mobileFirst: true,
      fade: true,
      asNavFor: $product_thumbnails,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    $product_thumbnails.slick({
      slidesToShow: 3.5,
      dots: false,
      arrows: true,
      centerMode: false,
      focusOnSelect: true,
      variableWidth: false,
      prevArrow: $(".prev-arrow"),
      nextArrow: $(".next-arrow"),
      asNavFor: $product_images,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    $product_thumbnails.on("afterChange", (event, slick, currentSlide) => {
      $photosCounterFirstSpan.text(`${slick.currentSlide + 1} / `);
    });

    //   $(".product__images__thumbnail").on("click", function() {
    // 	const index = $(this).attr("data-slick-index");
    // 	$product_images.slick("slickGoTo", index);
    //   });
  }

  /* --- Collection Page ----------------------------- */

  if (
    $("body").hasClass("template-collection") ||
    $("body").hasClass("template-all") ||
    $("body").hasClass("template-kulta-collection") ||
    $(".section-distributors-popup")
  ) {
    $(".button-add-to-cart").on("click", function (e) {
      e.preventDefault();
      var button = $(this);

      $(button).text("   ").addClass("loading");

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: $(this).parents("form").serialize(),
        success: function () {
          $(button)
            .html("Successfully added to your cart")
            .removeClass("loading")
            .addClass("success");

          jQuery.getJSON("/cart.js", function (cart) {
            $(".header__cart-count").text(cart.item_count);
          });

          setTimeout(function () {
            $(button).html("Add to Cart").removeClass("success");
          }, 3000);
        },
        error: function () {
          $(button).html("Please try again").removeClass("loading");

          setTimeout(function () {
            $(button).html("Add to Cart");
          }, 3000);
        },
      });
    });

    $(".button-stockists-trigger").click(function () {
      $(".bus-timetable__popup").addClass("shown");
    });

    $(".bus-timetable__close").click(function (e) {
      e.preventDefault();
      $(".bus-timetable__popup").removeClass("shown");
    });

    if (window.location.href.indexOf("#distributor-open") > -1) {
      $(".bus-timetable__popup").addClass("shown");
    }
  }

  /* --- Experience Guided Page ----------------------------- */
  if ($("body").hasClass("template-experience-guided")) {
    $videoBlock = $(".video-block");
    // check if there is a video block on the page
    if ($videoBlock.length) {
      var player = new Vimeo.Player(
        document.querySelector(".video-wrapper iframe")
      );
      player.pause();
      // only play vimeo if clicked
      $videoBlock.find(".v-video__button").click(function () {
        $(this).addClass("hidden");
        $videoBlock.find(".v-video__thumb img").addClass("hidden");
        player.play();
      });
    }
    $(".video-block .v-video__thumb").click(function () {
      if ($(this).find("img").hasClass("hidden")) {
        player.pause();
        $(".v-video__button").removeClass("hidden");
      } else {
        player.play();
      }
    });

    $(".vue-video .v-video__thumb").click(function () {
      console.log($(this).player());
    });

    // guided card slider
    var $guidedCardSlider = $(
      "#shopify-section-experience-guided-cards .section-cards"
    );

    if ($guidedCardSlider.length) {
      $("#shopify-section-experience-guided-cards .section-cards__cards").slick(
        {
          centerMode: true,
          arrows: true,
          prevArrow: $(".carousel-prev"),
          nextArrow: $(".carousel-next"),
          infinite: false,
          // autoplaySpeed: $collectionSlider.data('speed'),
          // adaptiveHeight: false,
          // variableWidth: true,
          slidesToShow: 1,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                arrows: true,
                prevArrow: $(".carousel-prev"),
                nextArrow: $(".carousel-next"),
                infinite: false,
                adaptiveHeight: true,
                variableWidth: false,
                slidesToShow: 1,
              },
            },
          ],
        }
      );
    }
  }

  /* --- Experience Page ----------------------------- */

  // if ($("body").hasClass("template-the-experience")) {
  $(".slideshow__content .button-primary").click(function (e) {
    var $this = $(this);
    var $sectionId = $(this).data("section");
    var headerHeight = $(".header").height();

    if ($sectionId !== undefined) {
      e.preventDefault();
      $("html, body").animate(
        {
          scrollTop: $("#" + $sectionId).offset().top - headerHeight,
        },
        600
      );
    }
  });

  $(".button-bus-timetable").click(function (e) {
    e.preventDefault();
    $(".bus-timetable__popup").addClass("shown");
  });

  $(".bus-timetable__close").click(function (e) {
    e.preventDefault();
    $(".bus-timetable__popup").removeClass("shown");
  });

  $(".button__trigger-popup").click(function (e) {
    var $this = $(this);
    var $popup = $(this).data("trigger");

    console.log($popup);

    e.preventDefault();
    $('[data-popup="' + $popup + '"]').addClass("shown");
  });

  $(".button__close").click(function (e) {
    e.preventDefault();
    $(".button__popup").removeClass("shown");
  });
  // }

  /* --- Accordion Toggle ----------------------------- */

  if (
    $("body").hasClass("template-kulta-collection") ||
    $("body").hasClass("template-the-experience") ||
    $("body").hasClass("template-contact") ||
    $("body").hasClass("template-book_a_ticket") ||
    $("body").hasClass("template-all") ||
    $(".section-collections-subscriptions")
  ) {
    $(".accordion__toggle").click(function () {
      var $this = $(this);
      var $siblingDropdown = $this.siblings(".accordion__dropdown");

      if ($this.hasClass("active")) {
        $this.removeClass("active");
        $siblingDropdown.removeClass("shown");
      } else {
        $this.addClass("active");
        $siblingDropdown.addClass("shown");
      }
    });
  }

  /* --- Tabs Toggle ----------------------------- */

  if (
    $("body").hasClass("template-weddings-events") ||
    $("body").hasClass("template-tours-packages") ||
    $("body").hasClass("template-the-experience") ||
    $("body").hasClass("template-book_a_ticket")
  ) {
    if (window.location.hash) {
      // If URL already contains hash
      var hash = window.location.href.split("#")[1];

      if (window.location.href.indexOf(hash) > -1) {
        $(".tab-content").removeClass("active");
        $(".tab-trigger").removeClass("active");
        $(".tab-image").removeClass("active");

        $('[data-tab="' + hash + '"]').addClass("active");
        $(".tab-content-" + hash).addClass("active");
        $(".tab-image-" + hash).addClass("active");
      }
    } else {
      // Add hash to URL if it doesn't exist
      var hash = $(".tab-trigger").first().attr("data-tab");
      if (hash) {
        window.location.hash = "#" + hash;
      }

      $('[data-tab="' + hash + '"]').addClass("active");
      $(".tab-content-" + hash).addClass("active");
      $(".tab-image-" + hash).addClass("active");
    }

    // Tab trigger function
    $(".tab-trigger").click(function () {
      var tab = $(this).attr("data-tab");
      window.location.hash = "#" + tab;

      $(".tab-content").removeClass("active");
      $(".tab-trigger").removeClass("active");
      $(".tab-image").removeClass("active");

      $(this).addClass("active");
      $(".tab-content-" + tab).addClass("active");
      $(".tab-image-" + tab).addClass("active");
    });

    // Slideshow to trigger tab functionality
    $(".slideshow__content .button-primary ").click(function (e) {
      var $this = $(this);
      var tab = $(this).attr("data-section");
      var headerHeight = $(".header").height();

      if (tab) {
        e.preventDefault();
        window.location.hash = "#" + tab;
        $(".tab-content").removeClass("active");
        $(".tab-trigger").removeClass("active");
        $(".tab-image").removeClass("active");

        $('[data-tab="' + tab + '"]').addClass("active");
        $(".tab-content-" + tab).addClass("active");
        $(".tab-image-" + tab).addClass("active");

        $("html, body").animate(
          {
            scrollTop: $(".tab-scroll-to").offset().top - headerHeight,
          },
          600
        );
      }
    });
  }

  /* --- Login Page ----------------------------- */

  if (
    $("body").hasClass("template-customers-login") ||
    $("body").hasClass("template-trade")
  ) {
    $("#ForgotPassword").click(function (e) {
      e.preventDefault();

      $("#CustomerLoginForm").addClass("hidden");
      $("#RecoverPasswordForm").removeClass("hidden");
    });

    $("#HideRecoverPasswordLink").click(function (e) {
      e.preventDefault();

      $("#CustomerLoginForm").removeClass("hidden");
      $("#RecoverPasswordForm").addClass("hidden");
    });
  }

  /* --- Addresses Page ----------------------------- */

  if ($("body").hasClass("template-customers-addresses")) {
    $("#AddressNewButton").click(function (e) {
      e.preventDefault();
      var $this = $(this);

      if ($this.hasClass("active")) {
        $this.html("Add a New Address").removeClass("active");
        $("#AddressNewForm").removeClass("shown");
      } else {
        $this.html("Cancel").addClass("active");
        $("#AddressNewForm").addClass("shown");
      }
    });

    $(".button-edit-address").click(function (e) {
      e.preventDefault();
      var $this = $(this);
      var $form = $this
        .parents(".account-address__address")
        .find(".account-address__edit");

      if ($this.hasClass("active")) {
        $this.html("Edit").removeClass("active");
        $form.removeClass("shown");
      } else {
        $this.html("Cancel").addClass("active");
        $form.addClass("shown");
      }
    });
  }

  /* --- Panel Video ----------------------------- */

  /* --- Booking form popup ----------------------------- */
  if (
    $("body").hasClass("template-weddings-events") ||
    $("body").hasClass("template-index")
  ) {
    $(".booking-modal-close").click(function (e) {
      if ($(".booking-modal-popup").hasClass("shown")) {
        $(".booking-modal-popup").removeClass("shown");
      }
    });
  }

  if ($("body").hasClass("template-all")) {
    $(".js-btn-trigger").on("click", function (e) {
      //get this id to open modal for this modal
      $id = $(this).data("id");

      $(".subscription_benefits").each(function () {
        console.log($(this).data("id") == $id);
        if (!$(this).hasClass("shown") && $(this).data("id") == $id) {
          $(this).addClass("shown");
        }
      });
    });

    $(".icon-close").on("click", function (e) {
      //find the id of this modal and close
      $parent = $(this).parents("div").find(".subscription_benefits");
      if ($parent.hasClass("shown")) {
        $parent.removeClass("shown");
      }
    });
  }

  /* --- Locals Page ----------------------------- */

  if ($("body").hasClass("template-locals")) {
    $(".collection-carousel").slick({
      arrows: true,
      prevArrow: $(".carousel-prev"),
      nextArrow: $(".carousel-next"),
      infinite: false,
      slidesToShow: 4,
      variableWidth: false,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            adaptiveHeight: true,
            variableWidth: false,
            slidesToShow: 1,
            centerMode: true,
            centerPadding: "40px",
            adaptiveHeight: false,
          },
        },
      ],
    });
  }
});

function autoScrollElementTop(element, offset = 150) {
  if (element != null) {
    const position = element.getBoundingClientRect();
    window.scroll({
      top: position.top + window.scrollY - offset,
      left: 0,
      behavior: "smooth",
    });
  }
}
